<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount } from 'vue'
import CustomList from "../../../compositions/CustomList.vue";
import ModalDialog from "../../../compositions/ModalDialog.vue";
import CsvLoader from "../../../compositions/CsvLoader.vue";
import SearchBox from "../../../compositions/SearchBox.vue";
import SelectBox from "../../../compositions/SelectBox.vue";
import TextBox from "../../../compositions/TextBox.vue";
import CheckBox from "../../../compositions/CheckBox.vue";
import PharmacyMedicineEditComponent from "../../Common/PharmacyMedicineEditComponent.vue";
import config from "../../../config.js";
import { errorAlert,confirmAlert,successAlert } from "../../../plugins/alert";
import { getFieldValue } from "../../../plugins/utility";
import qs from 'qs';
import axios from '../../../plugins/axios.ts';
import HelpAction from '../../../compositions/HelpAction.vue';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    currentPharmacy:{
      type:Object,
      required:true,
    },
    placeHolder:{
        type:String,
        default: () => {
            return '';
        }
    }
})

const isUploadFileDialog = ref(false);
const isUploadFileLoading = ref(false);
const headerLine = ref(0);
const yjCodeLine = ref(0);
const stockNumberLine = ref(0);
const priceLine = ref(0);
const uploadFile = ref(new Object());
const uploadFileData = ref([]);
const yjList = ref([]);
const stockNumberList = ref([]);
const priceList = ref([]);
const uploadFilehandler = (value:Object) => {
  uploadFile.value = value;
}
const uploadStart = () => {
  isUploadFileLoading.value = true;
}
const uploadComplete = (data) => {
  // 表示するために最大30データをセットする
  uploadFileData.value.splice(0);
  yjList.value.splice(0);
  stockNumberList.value.splice(0);
  priceList.value.splice(0);
  if (data.length > 0) {
    yjList.value.push('　');
    stockNumberList.value.push('　');
    priceList.value.push('　');
    for (let i=0;i<data[0].length;i++) {
      yjList.value.push(data[0][i]);
      stockNumberList.value.push(data[0][i]);
      priceList.value.push(data[0][i]);
    }
  }
  for (let i=0;i<data.length;i++) {
    if (i > 30) {
      break;
    }
    uploadFileData.value.push(data[i]);
  }
  isUploadFileLoading.value = false;
  //
}
const showUploadFileDialog = () => {
  isUploadFileDialog.value = true;
}
const closeUploadFileDialog = () => {
  isUploadFileDialog.value = false;
}
const uploadFileDataResult = async () => {
  if (yjCodeLine.value == 0) {
    errorAlert('YJコード読み込み列は必須です。');
    return;
  }
  if (stockNumberLine.value == 0) {
    errorAlert('在庫数読み込み列は必須です。');
    return;
  }
  if (updateStockDate.value == 0) {
    errorAlert('棚卸日時は必須です。');
    return;
  }
  let params = new FormData();
  params.append('upload_file', uploadFile.value);
  params.append('update_date',updateStockDate.value);
  params.append('header_line', headerLine.value);
  params.append('yj_line', yjCodeLine.value);
  params.append('stock_number_line', stockNumberLine.value);
  params.append('price_line', priceLine.value);
  isUploadFileLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_convert_stock_update,{method:"post",data:params});
    if (response.data.status == 200) {
      closeUploadFileDialog();
    }
  } finally {
    isUploadFileLoading.value = false;
  }
}
const updateStockDate = ref('');
const changeUpdateStockDate = (value) => {
  updateStockDate.value = value;
}

const isProfileUpdateDialog = ref(false);
const isProfileUpdateDialogLoading = ref(false);
const resetType = ref('nsips');
const showProfileUpdateDialog = (type) => {
  resetType.value = type;
  let checkField = (type == 'nsips' ? 'is_nsips_stop' : 'is_van_stop');
  if (!props.currentPharmacy[checkField]) {
    successAlert('現在リセットの必要はありません。');
    return;
  }
  isProfileUpdateDialog.value = true;
}
const closeProfileUpdateDialog = () => {
  isProfileUpdateDialog.value = false;
}
const updateProfile = async () => {
  let params = new FormData();
  params.append('reset_type', resetType.value);
  isProfileUpdateDialogLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_convert_profile_update,{method:"post",data:params});
    if (response.data.status == 200) {
      closeProfileUpdateDialog();
      location.reload();
    }
  } finally {
    isProfileUpdateDialogLoading.value = false;
  }
}
/////// VAN

</script>

<style scoped>
.header-color {
  background-color: #bab8b8;
}
.yj-color {
  background-color: rgb(253, 253, 76);
}
.stock-number-color {
  background-color: rgb(94, 251, 107);
}
.price-color {
  background-color: rgb(251, 94, 212);
}
</style>
<template>
<div ref="element" class="relative">
  <div class="absolute top-2 left-2">
    <help-action
      help-key="pharmacy_medicine_help"
    ></help-action>
  </div>
  <div class="w-full flex items-center justify-end p-2 bg-gray-100 rounded h-10">
  </div>
  <div class="w-full">
      <div class="m-1 md:w-1/5 mb-4">
          <a href="javascript:void(0)" @click="showUploadFileDialog" class="block text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 font-medium rounded-lg text-base px-5 py-3 w-full sm:w-auto text-center ml-2">他サービス棚卸ファイル読み込み</a>
      </div>
      <div class="m-1 md:w-1/5 mb-4">
          <a href="javascript:void(0)" @click="showProfileUpdateDialog('nsips')" class="block text-black bg-blue-300 hover:bg-blue-400 focus:ring-4 focus:ring-blue-200 font-medium rounded-lg text-base px-5 py-3 w-full sm:w-auto text-center ml-2">薬局フラグリセット</a>
      </div>
      <div class="m-1 md:w-1/5 mb-4">
          <a href="javascript:void(0)" @click="showProfileUpdateDialog('van')" class="block text-black bg-blue-300 hover:bg-blue-400 focus:ring-4 focus:ring-blue-200 font-medium rounded-lg text-base px-5 py-3 w-full sm:w-auto text-center ml-2">VANフラグリセット</a>
      </div>
  </div>
</div>

<modal-dialog
  :is-visible="isUploadFileDialog"
  width="60%"
  :close="closeUploadFileDialog"
  :isLoading="isUploadFileLoading"
>
  <template v-slot:header>
    棚卸ファイル読み込み
  </template>
  <template v-slot:default>
  <div class="mb-6">
    <div class="mb-3 px-3 py-2 md:mb-0 md:rounded-t">
      <p class="text-lg font-bold">読み込み設定</p>
    </div>
    <div class="md:border p-2">
      <table class="w-full">
        <tr class="border-b border-white">
          <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">棚卸ファイル選択(CSVファイル) <span class="inline-block px-1 text-xs font-bold text-red-500 rounded">必須</span></th>
          <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
            <csv-loader
              :value="uploadFile"
              :handler="uploadFilehandler"
              :loadStart="uploadStart"
              :loadComplete="uploadComplete"
            ></csv-loader>
          </td>
        </tr>
        <tr class="border-b border-white">
          <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">ヘッダ行指定 <span class="header-color">　</span></th>
          <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
            <input class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="number" v-model="headerLine" placeholder="">
          </td>
        </tr>
        <tr class="border-b border-white">
          <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">YJコード読み込み列  <span class="yj-color">　</span><span class="inline-block px-1 text-xs font-bold text-red-500 rounded">必須</span></th>
          <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
            <select class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" v-model="yjCodeLine">
              <option v-for="(yjValue,index) in yjList" :key="index" :value="index">{{ yjValue }}</option>
            </select>
          </td>
        </tr>
        <tr class="border-b border-white">
          <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">在庫数読み込み列  <span class="stock-number-color">　</span><span class="inline-block px-1 text-xs font-bold text-red-500 rounded">必須</span></th>
          <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
            <select class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" v-model="stockNumberLine">
              <option v-for="(stockNumberValue,index) in stockNumberList" :key="index" :value="index">{{ stockNumberValue }}</option>
            </select>
          </td>
        </tr>
      </table>
    </div>
    <div class="md:border p-2 h-40 overflow-auto">
      <table class="table-auto whitespace-nowrap min-w-full border text-center">
        <tr class="bg-white border-b " v-for="(csvData,index1) in uploadFileData" :key="index1">
          <td class="border-r bg-gray-400">
            {{ index1+1 }}
          </td>
          <td :class="'border-r' + ((index1+1) == headerLine ? ' header-color' : ((index2+1) == yjCodeLine ? ' yj-color' : ((index2+1) == stockNumberLine ? ' stock-number-color' : ((index2+1) == priceLine ? ' price-color' : ''))))" v-for="(csv,index2) in csvData" :key="index2">
            {{ csv }}
          </td>
        </tr>
      </table>
    </div>
    <div class="flex flex-col item-center md:w-auto">
      <div><span>棚卸を行った日時を指定してください。</span></div>
      <div class="md:w-2/5">
        <text-box
          :value="updateStockDate"
          type="datetime-local"
          :on-change="changeUpdateStockDate"
        ></text-box>
      </div>
    </div>
    <div class="flex">
      <div class="flex-row mr-2">
        <button type="button" @click="uploadFileDataResult" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">取り込む</button>
      </div>
      <div class="flex-row">
        <button type="button" @click="closeUploadFileDialog" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
      </div>
    </div>
  </div>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isProfileUpdateDialog"
  width="60%"
  :close="closeProfileUpdateDialog"
  :isLoading="isProfileUpdateDialogLoading"
>
  <template v-slot:header>
    {{ resetType == 'nsips' ? '薬局' : 'VAN' }}フラグリセット
  </template>
  <template v-slot:default>
  <div class="mb-6">
    <div class="mb-3 px-3 py-2 md:mb-0 md:rounded-t">
      <p class="text-lg font-bold">{{ resetType == 'nsips' ? '薬局' : 'VAN' }}の停止フラグをリセットします。
        <span class="text-red-800">※必ず問題が解決してからリセットしてください。</span>
        <div>原因：{{ currentPharmacy[resetType == 'nsips' ? 'nsips_stop_reason' : 'van_stop_reason'] }}</div>
      </p>
    </div>
    <div class="flex">
      <div class="flex-row mr-2">
        <button type="button" @click="updateProfile" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">リセットする</button>
      </div>
      <div class="flex-row">
        <button type="button" @click="closeProfileUpdateDialog" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
      </div>
    </div>
  </div>
  </template>
</modal-dialog>
</template>

